import { render, staticRenderFns } from "./Polars.vue?vue&type=template&id=0024fb7e&"
import script from "./Polars.vue?vue&type=script&lang=js&"
export * from "./Polars.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports